jQuery(function(){
  if ($('.data-archive-block').length > 0) {
    console.log('Data Archive Ready');
    
    const baseUrl = $('#base-url').data('base-url');
    let currPage = 1;
    let totalPages = 0;
    let timeoutVar;
    let blockApi = false;
    let downloadCsvUrl;
    let activeParams = '';

    /////////////////////////////////////////////////////////////////////////////
    // API tags and countrie ////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////

    // API settings
    const settings = {
      "url": baseUrl+"api/idea_country/dataarchiveparamsresource",
      "method": "GET",
      "timeout": 0,
      "headers": {
        "Content-Type": "application/json"
      },
      error: function(error) {
        console.log('error', error);
      }
    };

    // Ajax call to get tags and countries
    $.ajax(settings).done(function (response) {
      // console.log('response', response);

      let activeTags = [];

      const apiTags = response.tags;
      const regionsAndCountries = response.regions_and_countries;

      // let apiTags = [
      //   { "label": "Democracy", "id": 1 },
      //   { "label": "Demonstration", "id": 2 },
      //   { "label": "Election", "id": 3 },
      //   { "label": "Voting", "id": 4 },
      // ];

      /////////////////////////////////////////////////////////////////////////////
      // Tags search //////////////////////////////////////////////////////////////
      /////////////////////////////////////////////////////////////////////////////

      $('#reset-search-input').on('click', function(){
        $('#input-tags').val('');
        renderAvailableSearchTags();
      });

      // Handler for tags search autocomplete
      $('#input-tags').on('keyup', function(){
        renderAvailableSearchTags();
      });
  
      function renderAvailableSearchTags() {
        const value = $('#input-tags').val();
        const tagsFoundContainer = $('#tags-found-container');
  
        let tagsFound = [];

        if (value.length > 0) {
          $('#reset-search-input').show();
        } else {
          $('#reset-search-input').hide();
        }
  
        // Start auto search of tags when user keyed in 2 charcters or more
        if (value.length > 1) {
          tagsFound = apiTags.filter((item, index) => {
            return item.label.toLowerCase().indexOf(value.toLowerCase(), 0) >= 0;
          })
        }
  
        tagsFoundContainer.find('.tag-found').remove();
        tagsFoundContainer.addClass('hidden');
  
        if (tagsFound.length > 0) {
          let tagsRendered = 0;
  
          $.each(tagsFound, function() {
            const label = $(this)[0].label;
            const id = $(this)[0].id;
  
            const foundInActiveTags = activeTags.find((item) => {
              return item.id === id && item.type === 'tag';
            });
  
            if (foundInActiveTags === undefined) {
              tagsFoundContainer.append('<div class="tag-found" data-id="'+id+'" data-type="tag">'+label+'</div>');
              tagsRendered++;
            }
          });
  
          if (tagsRendered > 0) {
            tagsFoundContainer.removeClass('hidden');
          }
          
          $('.tag-found').on('click', function(){
            const id = $(this).data('id');
            const type = $(this).data('type');
            const label = $(this).text();
      
            const tag = {
              id,
              type,
              label
            };
      
            // Add to active tags
            addActiveTags(tag);
            getResultsWithParams(activeTags);
          });
        }
      }
      
      /////////////////////////////////////////////////////////////////////////////
      // Active tags //////////////////////////////////////////////////////////////
      /////////////////////////////////////////////////////////////////////////////
  
      function addActiveTags(tag) {
        const found = activeTags.find((item) => {
          return (item.id === tag.id && item.type === tag.type);
        });
  
        if (found === undefined) {
          activeTags.push(tag);
        }
  
        renderActiveTags();
        renderAvailableSearchTags();
      }
  
      function removeActiveTag(tag) {
        // console.log('removeActiveTag', activeTags);
        let foundIndex = -1;
  
        activeTags.forEach((item, index) => {
          if (item.id === tag.id && item.type === tag.type) {
            foundIndex = index;
          }
        });
  
        if (foundIndex >= 0) {
          activeTags.splice(foundIndex, 1);
        }

        if (tag.type === 'time_from' || tag.type === 'time_to') {
          $('select.select-time-range[data-type='+tag.type+']').val('');
          $('select.select-time-range[data-type='+tag.type+']').trigger('change');
        }

        if (tag.type === 'extra') {
          $('input.checkbox-extra-filter[value='+tag.id+']').prop('checked', false);
        }
  
        renderActiveTags();
        renderAvailableSearchTags();
        // console.log('removeActiveTag', activeTags);

        clearTimeout(timeoutVar);

        timeoutVar = setTimeout(() => {
          getResultsWithParams(activeTags);
        }, 250);

        // getResultsWithParams(activeTags);
      }
  
      // Refresh active tags list
      function renderActiveTags() {
        $('.das-tag').remove();
  
        if (activeTags.length > 0) {
          $.each(activeTags, function() {
            const id = $(this)[0].id;
            const type = $(this)[0].type;
            const label = $(this)[0].label;
            
            $('<div class="das-tag">'+label+'<div class="das-tag-remove" data-id="'+id+'" data-type="'+type+'"></div></div>').insertBefore($('#remove-all-active-tags'));
          });

            // Remove a tag click handler
          $('body').find('.das-tag-remove').on('click', function(){
            const id = $(this).data('id');
            const type = $(this).data('type');
            const label = $(this).text();
      
            const tag = {
              id,
              type,
              label
            };
      
            removeActiveTag(tag);

            // console.log('before vSelectCountries.updateOption');
            vSelectCountries.updateOption(id, false);
          });
  
          $('.active-seach-tags-element').removeClass('!hidden');
        } else {
          $('.active-seach-tags-element').addClass('!hidden');
        }
      }
  
      $('#remove-all-active-tags').on('click', function(){
        // console.log('activeTags', activeTags);
        blockApi = true;
        
        vSelectCountries.unselectAll();
        $('#month_from').val('');
        $('#month_from').trigger('change');
        $('.checkbox-extra-filter').prop('checked', false);

        activeTags = [];
        renderActiveTags();
        renderAvailableSearchTags();

        blockApi = false;

        getResults();
      });
  
      /////////////////////////////////////////////////////////////////////////////
      // Regions & countries //////////////////////////////////////////////////////
      /////////////////////////////////////////////////////////////////////////////
      const selectCountriesElm = $('#select-countries');

      $.each(regionsAndCountries, function() {
        const region = $(this)[0];
        // console.log('region', region.region);

        const optGroup = $('<optgroup label="'+region.region+'"></optgroup>');

        selectCountriesElm.append(optGroup);

  
        $.each(region.countries, function() {
          const country = $(this)[0];

          optGroup.append('<option value="'+country.id+'">'+country.label+'</option>');
        });
      });

      const vSelectCountries = $('.my-vselect').vSelect({
        'onChange': function(option) { 
          // console.log(option);

          const tag = {
            'id': option.value,
            'type': 'country',
            'label': option.label
          }

          if (option.checked) {
            addActiveTags(tag);
          } else {
            removeActiveTag(tag);
          }

          clearTimeout(timeoutVar);

          timeoutVar = setTimeout(() => {
            getResultsWithParams(activeTags);
          }, 250);
        }
      });

      /////////////////////////////////////////////////////////////////////////////
      // Time range ///////////////////////////////////////////////////////////////
      /////////////////////////////////////////////////////////////////////////////

      const today = new Date();
      populateTimeToOptions($('#month_from'));

      $('.select-time-range').on('change', function(){
        const thisElm = $(this);
        const type = thisElm.data('type');
        const label = thisElm.data('label');
        const value = thisElm.val();
        const textLabel = thisElm.find('option:selected').text();

        const isValueIsSelected = (value == '' ? false : true);
        
        // For time-from select list
        if (type === 'time_from') {
          activeTags = activeTags.filter((item, key) => {
            return (item.type !== 'time_from' && item.type !== 'time_to');
          });
          
          // Remove all options from time-to select list
          $('#month_to option').each(function(index) {
            if (index > 0) {
              $(this).remove();
            }
          });

          // If time-from has value
          if (isValueIsSelected) {
            const newYearFrom = parseInt(value.substring(0,4));
            const newMonthFrom = parseInt(value.substring(5,7));
            
            // Repopulate time to options starting from current selected time-from value
            // - 2 so that starting month is same as time-from select list
            populateTimeToOptions($('#month_to'), newMonthFrom - 2, newYearFrom);
            $('#month_to').prop('disabled', false);

            // Add active tag of time-from
            const tag = {
              id: value, // Value of select list
              label: label + textLabel,
              type: type
            }

            addActiveTags(tag);
          } else {
            // Disable time to if time from has no selected value
            $('#month_to').prop('disabled', true);
            renderActiveTags();
          }
        }

        if (type === 'time_to') {
          // Remove active tags
          $.each(activeTags, function(index) {
            const tag = $(this)[0];

            if (tag.type === 'time_to') {
              removeActiveTag(tag);
            }
          })

          if (isValueIsSelected) {
            const tag = {
              id: value,
              label: label + textLabel,
              type: type
            }
            
            addActiveTags(tag);
          }
        }

        getResultsWithParams(activeTags);
      });

      function populateTimeToOptions(elm, bM = 4, bY = 2022) {
        const beginMonth = bM; // Month start with 0
        const beginYear = bY;
        // const thisMonth = today.getMonth();
        const thisMonth = 2;
        // const thisYear = today.getFullYear();
        const thisYear = 2023;
        const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

        let countYear = beginYear;
        let countMonth = beginMonth + 1;

        while (countYear < thisYear || countMonth <= thisMonth) {
          const label = months[countMonth] + ' ' + countYear

          countMonth++; // Increment at beginning, becoz month start with 0

          let monthString = countMonth + '';

          if (monthString.length < 2) { monthString = '0' + monthString }

          let value = countYear + '-' + monthString;

          elm.append('<option value="'+value+'">'+label+'</option>');


          if (countMonth > 11) {
            countMonth = 0;
            countYear++;
          }
        }
      }

      /////////////////////////////////////////////////////////////////////////////
      // Checkboxes ///////////////////////////////////////////////////////////////
      /////////////////////////////////////////////////////////////////////////////

      $('.checkbox-extra-filter').on('click', function() {
        const elm = $(this);
        const value = elm.val();
        const label = elm.data('label');
        const checked = elm.is(":checked");
        const tag = {
          id: value,
          label,
          type: 'extra'
        }

        if (checked) {
          addActiveTags(tag);
        } else {
          removeActiveTag(tag);
        }

        getResultsWithParams(activeTags);
      });

      // console.log('apiTags', apiTags);

      const queryString = window.location.search;
      
      if (queryString === '') {
        getResults();
      } else {
        const paramTagId = parseInt(queryString.substring(5, queryString.length));

        let paramTagFound = apiTags.filter((tag, index) => {
          return tag.id === paramTagId;
        });

        const paramTag = {
          id: paramTagFound[0].id,
          label: paramTagFound[0].label,
          type: 'tag'
        }

        addActiveTags(paramTag);
        getResultsWithParams(activeTags);
      }
    }); // End of $.ajax for tags and countries

    $('.page-nav.prev').on('click', function(){
      if (currPage <= 1) { return; }

      currPage--;

      if (activeParams === '') {
        getResults('?page='+(currPage));
      } else {
        getResults(activeParams+'&page='+(currPage));
      }
    });

    $('.page-nav.next').on('click', function(){
      if (currPage >= totalPages) { return; }

      currPage++;

      if (activeParams === '') {
        getResults('?page='+(currPage));
      } else {
        getResults(activeParams+'&page='+(currPage));
      }
    });

    function getResults(params='') {
      /////////////////////////////////////////////////////////////////////////////
      // API get data archive results /////////////////////////////////////////////
      /////////////////////////////////////////////////////////////////////////////

      // console.log('function getResults / params:', params, 'active:', activeParams);

      let url = baseUrl + 'api/idea_country/dataarchiveresource';

      if (params !== '') {
        url+=params;
        downloadCsvUrl = url+'&download=1';
      } else {
        downloadCsvUrl = url+'?download=1';
      }

      $('#download-csv').attr('href', downloadCsvUrl);

      // console.log('API URL: ', url);

      // API settings
      const settings = {
        "url": url,
        "method": "GET",
        "timeout": 0,
        "headers": {
          "Content-Type": "application/json"
        },
        error: function(error) {
          console.log('error', error);
        }
      };

      $('#data-archive-loading-blocker').fadeIn(1000);

      const resultsElm = $('#data-archive-results');

      $('#message-no-results').hide();

      resultsElm.html('');
      $('.pagination').hide();

      $.ajax(settings).done(function (response) {
        // console.clear();
        // console.log('getResults response', response.total_pages, response.data);

        const data = response.data;

        $('.page-nav').prop('disabled', false);
        $('.page-nav').css('opacity', 1);
        $('.page-nav').css('pointer-events', 'auto');

        if (data === undefined) {
          $('#message-no-results').show();
          $('#data-archive-loading-blocker').fadeOut(1000);
          return;
        } else {
          totalPages = response.total_pages;

          $('#current-page').text(currPage);
          $('#total-pages').text(response.total_pages);

          if (currPage == 1) {
            $('#button-prev-page').prop('disabled', true);
            $('#button-prev-page').css('opacity', 0.4);
            $('#button-prev-page').css('pointer-events', 'none');
          }
  
          if (currPage >= response.total_pages) {
            $('#button-next-page').prop('disabled', true);
            $('#button-next-page').css('opacity', 0.4);
            $('#button-next-page').css('pointer-events', 'none');
          }

          if (totalPages > 1) {
            $('.pagination').show();
          }
        }

        $.each(data, function(index) {
          const value = $(this)[0]
        
          const cardElm = $('<div class="data-archive-card relative before:content-[\'\'] before:block before:shadow-cdCard before:pointer-events-none before:absolute before:top-0 before:bottom-0 before:left-[-1.5rem] before:right-[-1.5rem] lg:before:right-0"></div>');

          const eventElm = $('<div class="py-6 lg:py-10 lg:pr-10"></div>');

          eventElm.append($('<h3 class="h4 flex items-center"><span>'+value.title+'</span></h3>'));
          eventElm.append($('<h4 class="h5">'+value.heading+'</h4>'));
          eventElm.append($(value.body));

          eventElm.append($('<div class="gsod-jump-links mb-5"><a href="'+baseUrl.substring(0, baseUrl.length - 1)+value.permalink+'" class="jump-link uppercase"><span class="text-xs">Read more</span></a></div>'));

          const tagsAndAttributesElm = $('<div class="flex justify-between items-start flex-shrink gap-x-8"></div>');
          const gsodTagsElm = $('<div class="gsod-tags flex flex-wrap gap-2"></div>');

          if (value.tags !== null) {
            $.each(value.tags, function(index) {
              const tag = $(this)[0]
              const tagElm = $('<a href="' + baseUrl + 'data-archive?tag='+tag.id+'" class="gsod-tag">'+tag.label+'</a>');
              gsodTagsElm.append(tagElm);
            });

            tagsAndAttributesElm.append(gsodTagsElm);
          } else {
            tagsAndAttributesElm.append('<div></div>');
          }

          const gsodAttributesElm = $('<div class="gsod-attributes flex flex-shrink-0 gap-x-1"></div>');

          let attributeValue;

          // console.log('value.attributes', value.attributes);

          // Representative Goverment
          attributeValue = value.attributes.representative_government;
          
          if (attributeValue !== '') {
            attributeValue = attributeValue.toLowerCase();
            gsodAttributesElm.append('<div class="attribute-tooltip-hover relative" data-tooltip="Representative Government"><img src="' + baseUrl + 'themes/custom/gsod/src/assets/icons/icon-representative-government-'+attributeValue+'.svg" alt="Representative government '+attributeValue+'" class="gsod-attribute"></div>');
          }

          // Fundamental Rights
          attributeValue = value.attributes.fundamental_rights;
          
          if (attributeValue !== '') {
            attributeValue = attributeValue.toLowerCase();
            gsodAttributesElm.append('<div class="attribute-tooltip-hover relative" data-tooltip="Fundamental Rights"><img src="' + baseUrl + 'themes/custom/gsod/src/assets/icons/icon-fundamental-rights-'+attributeValue+'.svg" alt="Fundamental rights '+attributeValue+'" class="gsod-attribute"></div>');
          }


          // Checks On Government
          attributeValue = value.attributes.checks_on_government;
          
          if (attributeValue !== '') {
            attributeValue = attributeValue.toLowerCase();
            gsodAttributesElm.append('<div class="attribute-tooltip-hover relative" data-tooltip="Checks On Government"><img src="' + baseUrl + 'themes/custom/gsod/src/assets/icons/icon-checks-on-government-'+attributeValue+'.svg" alt="Checks on government '+attributeValue+'" class="gsod-attribute"></div>');
          }


          // Impartial Administration
          attributeValue = value.attributes.impartial_administration;
          
          if (attributeValue !== '') {
            attributeValue = attributeValue.toLowerCase();
            gsodAttributesElm.append('<div class="attribute-tooltip-hover relative" data-tooltip="Impartial Administration"><img src="' + baseUrl + 'themes/custom/gsod/src/assets/icons/icon-impartial-administration-'+attributeValue+'.svg" alt="Impartial administration '+attributeValue+'" class="gsod-attribute"></div>');
          }


          // Participatory Engagement
          attributeValue = value.attributes.participatory_engagement;
          
          if (attributeValue !== '') {
            attributeValue = attributeValue.toLowerCase();
            gsodAttributesElm.append('<div class="attribute-tooltip-hover relative" data-tooltip="Participatory Engagement"><img src="' + baseUrl + 'themes/custom/gsod/src/assets/icons/icon-participatory-engagement-'+attributeValue+'.svg" alt="Participatory engagement '+attributeValue+'" class="gsod-attribute"></div>');
          }


          tagsAndAttributesElm.append(gsodAttributesElm);

          eventElm.append(tagsAndAttributesElm);

          cardElm.append(eventElm);

          setTimeout(() => {
            resultsElm.append(cardElm);
            $('#data-archive-loading-blocker').fadeOut(1000);
          }, 250);
        });

        // Tooltip for attributes
        $('body').on('mouseenter', '.attribute-tooltip-hover', function() {
          const tooltip = $(this).data('tooltip');
          const tt = $(this).find('img');
          
          $('body').append('<div class="attribute-tooltip"><div class="tooltip-content">' + tooltip + '</div></div>');

          $('.attribute-tooltip').css('top', tt.offset().top);
          $('.attribute-tooltip').css('left', tt.offset().left + (tt.width() / 2));
        });

        $('body').on('mouseleave', '.attribute-tooltip-hover', function() {
          $('.attribute-tooltip').remove();
        });
      });
    }

    function getResultsWithParams(activeTags) {
      if (activeTags.length <= 0) { getResults(); return; }

      let params = [];

      if (blockApi) { return }
      // console.log('getResultsWithParams', activeTags);
      
      let tags = activeTags.filter((item, key) => {
        return item.type === 'tag';
      });

      let countries = activeTags.filter((item, key) => {
        return item.type === 'country';
      });

      let timeFrom = activeTags.filter((item, key) => {
        return item.type === 'time_from';
      });

      let timeTo = activeTags.filter((item, key) => {
        return item.type === 'time_to';
      });

      let dsr = activeTags.filter((item, key) => {
        return item.id === 'dsr' && item.type === 'extra';
      });

      let rfe = activeTags.filter((item, key) => {
        return item.id === 'rfe' && item.type === 'extra';
      });

      // console.log('Params', tags, '|', countries, '|', timeFrom, '|', timeTo, '|', dsr, '|', rfe);

      let temp = [];
      let tagParams;

      if (tags.length > 0) {
        tagParams = 'tag='

        $.each(tags, function(index) {
          const value = $(this)[0]
          temp.push(value.id);
        });

        tagParams+=temp.join(',');
        params.push(tagParams);
      }

      temp = [];
      let countryParams;

      if (countries.length > 0) {
        countryParams = 'country='

        $.each(countries, function(index) {
          const value = $(this)[0]
          temp.push(value.id);
        });

        countryParams+=temp.join(',');
        params.push(countryParams);
      }

      if (timeFrom.length > 0) {
        params.push('from='+timeFrom[0].id);
      }

      if (timeTo.length > 0) {
        params.push('to='+timeTo[0].id);
      }

      if (dsr.length > 0) {
        params.push('dsr=1');
      }

      if (rfe.length > 0) {
        params.push('rfe=1');
      }

      urlParams = '?' + params.join('&');

      console.log('urlParams', urlParams);

      currPage = 1;
      activeParams = urlParams;
      getResults(urlParams);
    } // End of getResultsWithParams

    /////////////////////////////////////////////////////////////////////////////
    // Collapse for filters UI on mobile view ///////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////

    const filtersCollapseToggle = $('#toggle-filters-collapse');
    const filtersCollapse = $('#collapse-filters');

    let filterCollapseHeight = $('#filter-collapse-body').height();
    filtersCollapse.css('height', filterCollapseHeight+'px');

    filtersCollapseToggle.on('click', function(){
      if ($(this).hasClass('active')) { // Collapse
        filterCollapseHeight = $('#filter-collapse-body').height();
        filtersCollapse.css('height', filterCollapseHeight+'px');

        setTimeout(() => {
          $(this).removeClass('active');
          filtersCollapse.addClass('close');
        }, 50);
      } else { // Expand
        filterCollapseHeight = $('#filter-collapse-body').height();
        filtersCollapse.css('height', filterCollapseHeight+'px');

        $(this).addClass('active');
        filtersCollapse.removeClass('close');

        setTimeout(() => {
          filtersCollapse.css('height', 'auto');
        }, 100);
      }
    });
  } // End if
});
